const COAPPLICANT_TAG = 'coapplicant_'

export const wisconsinFieldNames = {
    maritalStatus: 'wiMaritalStatus',
    isSpouseAddressSame: 'wiIsSpouseAddressSame',
    spouseFirstName: 'wiSpouseFirstName',
    spouseLastName: 'wiSpouseLastName',
    spouseStreet: 'wiSpouseStreet',
    spouseApt: 'wiSpouseApt',
    spouseCity: 'wiSpouseCity',
    spouseState: 'wiSpouseState',
    spouseZip: 'wiSpouseZip',
}

export const coapplicantWisconsinFieldNames = Object.keys(
    wisconsinFieldNames,
).reduce(
    (acc, key) => {
        const currentKey = key as keyof typeof wisconsinFieldNames

        acc[currentKey] = `${COAPPLICANT_TAG}${wisconsinFieldNames[currentKey]}`

        return acc
    },
    {} as typeof wisconsinFieldNames,
)
